export default __webpack_public_path__ + "static/baslac-b76df65d1d8a58b62e52bf94a5465623.webp";